import React from 'react';
import s from './Card.module.css';

interface CardProps {
  imageUrl: string;
  title: string;
  price: number | string;
  alt?: string;
  onClick?: () => void;
}

export const Card: React.FC<CardProps> = ({
  imageUrl,
  title,
  price,
  alt = 'Product image',
  onClick,
}) => {
  return (
    <div className={s.card} onClick={onClick}>
      <div className={s.imageContainer}>
        <img src={imageUrl} alt={alt} className={s.image} />
      </div>
      <div className={s.content}>
        <h3 className={s.title}>{title}</h3>
        <p className={s.price}>
          Price: {typeof price === 'number' ? `$${price.toFixed(2)}` : `$${price}`}
        </p>
      </div>
    </div>
  );
};

export default Card;